<template>
  <div>
    <v-data-table
      :headers="aggregationTable.headers"
      :items="filteredItems"
      :header-props="{ sortByText: 'ソート' }"
      no-data-text="データがありません"
      hide-default-footer
      :items-per-page="-1"
      class="aggregation-table"
      :class="{ 'fixed-first-column': isUserAggregation }"
    >
      <template
        v-for="header in aggregationTable.businessRuleHeaders"
        #[`item.${header.value}`]="{ item }"
      >
        <AggregationTableCell
          :key="`cell-${item.id || item.name}-${header.value}`"
          :value="item[header.value]"
          :is-boolean="isBooleanItem(item, header.value)"
          :is-number="isNumberItem(item, header.value)"
          :is-new="false"
          :is-editing="false"
          :input-type="inputType(item, header.value)"
          :number-text="numberText(item, header.value)"
        />
      </template>

      <template #[`body.prepend`]>
        <tr>
          <td
            v-for="header in aggregationTable.headers"
            :key="header.value"
            :class="['font-weight-bold', header.cellClass || header.class]"
          >
            {{ accRow[header.value] }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import useAggregationTable from '../composables/useAggregationTable'
import AggregationTableCell from './AggregationTableCell.vue'

export default {
  name: 'ReadOnlyAggregationTable',
  components: {
    AggregationTableCell,
  },
  props: {
    aggregation: {
      type: Object,
      default: () => ({
        attributes: {
          id: null,
          name: '',
          description: '',
          businessRules: { data: [] },
          results: { data: [] },
          contexts: { data: [{ attributes: { results: { data: [] } } }] },
        },
      }),
    },
  },
  setup(props) {
    const {
      aggregationTable,
      isUserAggregation,
      isBooleanItem,
      isNumberItem,
      inputType,
      numberText,
    } = useAggregationTable(props, () => {})

    const filteredItems = computed(() => aggregationTable.value.items.filter(item => aggregationTable.value.businessRuleHeaders.some(header => {
      const val = item[header.value]

      return val !== null && val !== undefined && val !== ''
    })))

    const accRow = computed(() => {
      const sums = {}
      aggregationTable.value.headers.forEach(header => {
        if (header.value === 'name') {
          sums[header.value] = '合計'
        } else {
          const total = filteredItems.value.reduce((acc, item) => {
            const val = item[header.value]
            if (val === null || val === undefined || val === '') return acc
            const numVal = Number(val)

            return Number.isNaN(numVal) ? acc : acc + numVal
          }, 0)
          sums[header.value] = total
        }
      })

      return sums
    })

    return {
      aggregationTable,
      isUserAggregation,
      isBooleanItem,
      isNumberItem,
      inputType,
      numberText,
      filteredItems,
      accRow,
    }
  },
}
</script>

<style lang="scss">
@import '~@core/preset/preset/mixins.scss';

@include theme--child(aggregation-table) using ($material) {
  th.fixed-cell,
  td.fixed-cell {
    position: sticky !important;
    position: -webkit-sticky !important;
    left: 0;
    z-index: 3;
    background: map-deep-get($material, 'app-bar');
  }

  th.fixed-cell {
    z-index: 4;
  }

  .v-progress-linear {
    z-index: 5;
  }
}

.aggregation-table {
  white-space: nowrap;
}
</style>
